import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';
import {RxAuthService} from '../rx-auth/rx-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CustomChartService {
  private apiUrl = `${environment.backend_base}main/visualizations`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private auth: RxAuthService
  ) {}
  createCustomChart(chartId: number , chartContent: any ): Observable<any> {
    const body = {chart_id: chartId, chart_content: chartContent};
    return this.http.post<any>(
      `${this.apiUrl}/create_custom_chart/`,
      body,
      this.auth.httpOptions
    );
  }
}
